import DisclaimerText from './DisclaimerText';
export default DisclaimerText;